// frontend/src/components/UI/ArticleCard.js

import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

/**
 * Hilfsfunktion, um HTML-Tags für eine Vorschau zu entfernen.
 */
function stripHTML(html = '') {
  return html.replace(/<[^>]+>/g, '');
}

// Helfer: Falls ein Pfad mit "/uploads" beginnt => prefix mit "https://entecity.ch"
function getFullMediaUrl(path) {
  if (!path) return '';
  if (path.startsWith('/uploads')) {
    return `https://entecity.ch${path}`;
  }
  return path;
}

const ArticleCard = ({ article }) => {
  const { _id, title, slug, publishDate, category, content, media } = article;
  const dateStr = publishDate
    ? new Date(publishDate).toLocaleDateString()
    : 'Entwurf';

  // Bilder + Videos für mini-Swiper
  const allMedia = [
    ...(media?.images || []),
    ...(media?.videos || [])
  ];

  // HTML-Tags für Vorschau entfernen
  const snippet = stripHTML(content).substring(0, 130);

  return (
    <div className="bg-white shadow-md rounded overflow-hidden mb-4">
      {allMedia.length > 0 ? (
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000 }}
          loop
          style={{ width: '100%', height: 'auto' }}
        >
          {allMedia.map((m, idx) => {
            const fullUrl = getFullMediaUrl(m);

            // Container for consistent square (300×300 max)
            return (
              <SwiperSlide key={idx}>
                <div className="mx-auto w-full max-w-[300px] aspect-square">
                  {m.match(/\.(mp4|mov|avi)$/i) ? (
                    <video
                      src={fullUrl}
                      controls
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <img
                      src={fullUrl}
                      alt={`media-${idx}`}
                      className="w-full h-full object-cover"
                    />
                  )}
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      ) : (
        // Fallback für keinen Media
        <div className="mx-auto w-full max-w-[300px] aspect-square">
          <img
            src="https://entecity.ch/uploads/default-image.jpg"
            alt={title}
            className="w-full h-full object-cover"
          />
        </div>
      )}

      <div className="p-4">
        <Link to={`/articles/${slug}`}>
          <h3 className="text-xl font-heading text-blue-600 mb-2 hover:underline">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-gray-500 mb-2">
          {dateStr} | {category}
        </p>
        <p className="text-gray-700">{snippet}...</p>
        <Link
          to={`/articles/${slug}`}
          className="text-blue-600 font-medium mt-2 inline-block hover:underline"
        >
          Weiterlesen
        </Link>
      </div>
    </div>
  );
};

export default ArticleCard;
